import { StateCreator } from "zustand";

export const AdminPanelTabs = {
    userManagement: "userManagement",
    bankHolidays: "bankHolidays",
    selfCheck: "selfCheck",
    picklists: "picklists",
} as const;

export const AdminPanelUserManagementTabs = {
    users: "users",
    groups: "groups",
    permissions: "permissions",
} as const;
export type AdminPanelUserManagementTabTypes = typeof AdminPanelUserManagementTabs[keyof typeof AdminPanelUserManagementTabs];

export type AdminPanelSubTabTypes = AdminPanelUserManagementTabTypes | "";
export type AdminPanelTabTypes = typeof AdminPanelTabs[keyof typeof AdminPanelTabs];

export interface AdminPanelTabsState {
    mainTab: AdminPanelTabTypes;
    subTab: AdminPanelSubTabTypes;
}

export interface AdminPanelSlice {
    adminPanelTabs: AdminPanelTabsState;
    setAdminPanelTabs: (tabs: AdminPanelTabsState) => void;
    updateAdminPanelTabs: (partialTabs: Partial<AdminPanelTabsState>) => void;
}

const initialAdminPanelTabsState: AdminPanelTabsState = {
    mainTab: AdminPanelTabs.userManagement,
    subTab: AdminPanelUserManagementTabs.users,
};

export const createAdminPanelSlice: StateCreator<AdminPanelSlice, [], [], AdminPanelSlice> = (set) => ({
    adminPanelTabs: initialAdminPanelTabsState,

    setAdminPanelTabs: (tabs) => set({ adminPanelTabs: tabs }),
    updateAdminPanelTabs: (partialTabs) => set((state) => ({ adminPanelTabs: { ...state.adminPanelTabs, ...partialTabs } })),
});
